import { useEffect, useState } from "react";
import { api } from "./api";

let cached = null;
let inflight = null;

export function useVoiceStatus() {
    const [status, setStatus] = useState(cached || { stt: false, tts: false });
    useEffect(() => {
        if (cached) return;
        inflight = inflight || api.voiceStatus().then(s => { cached = s; return s; }).catch(() => ({ stt: false, tts: false }));
        inflight.then(setStatus);
    }, []);
    return status;
}
